import { cn } from "@/lib/utils";
import { Fragment, ReactNode, useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

interface IDropdownMenu {
  children: ReactNode;
  as?: any;
  head: ReactNode;
  disabled?: boolean;
  className?: string;
  classNameActive?: string;
  headClassName?: string;
  itemClassName?: string;
}

const Dropdown = {
  Menu: ({
    children,
    head,
    disabled = false,
    as = "button",
    className,
    classNameActive = "",
    itemClassName,
  }: IDropdownMenu) => {
    const [open, setOpen] = useState(false);
    return (
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger asChild>
          {as === "button" ? (
            <button
              className={cn(className, {
                [classNameActive]: open,
              })}
            >
              {head}
            </button>
          ) : (
            <div
              className={cn(className, {
                [classNameActive]: open,
              })}
            >
              {head}
            </div>
          )}
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="max-h-[60dvh] overflow-y-auto overscroll-x-none sid-scrollbar"
        >
          {children}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  },
  Item: ({ children, ...props }) => {
    return (
      <DropdownMenuItem {...props}>
        {props.icon ? (
          <div className="mr-0.5 w-5">{props.icon}</div>
        ) : (
          <Fragment />
        )}
        {children}
      </DropdownMenuItem>
    );
  },
  Divider: () => {
    return <div className="mx-2 my-3 border-b" />;
  },

  Heading: ({ children }) => {
    return (
      <div className="mx-2 my-3 font-semibold text-gray-500 dark:text-gray-400 text-xs uppercase">
        {children}
      </div>
    );
  },
};

export default Dropdown;
